export default "__VITE_ASSET__3JKrGUM9__"